module.exports = __webpack_public_path__ + "img/5d.e59b4f09.png";